import { FunctionComponent } from 'react';
import { useForm } from 'react-hook-form';
import { UserCreateFormSchema, UserFormModel, UserFormSchema } from './UserFormModel';
import { zodResolver } from '@hookform/resolvers/zod';
import UserFormDisplay from './UserFormDisplay';
import { UserModel } from '../../../types/UserModel';

interface UserFormLogicProps {
  initialValues: UserFormModel;
  onSubmit: (data: UserFormModel) => Promise<{ success: boolean; fieldErrors?: Record<string, string> }>;
  isCreate?: boolean;
  userId?: number;
  userData?: UserModel;
}

const UserFormLogic: FunctionComponent<UserFormLogicProps> = ({ initialValues, onSubmit, isCreate, userId, userData }) => {
  const form = useForm<UserFormModel>({
    mode: 'onSubmit',
    defaultValues: initialValues,
    resolver: zodResolver(isCreate ? UserCreateFormSchema : UserFormSchema),
  });

  const handleSubmit = async (data: UserFormModel) => {
    const result = await onSubmit(data);

    if (result.success) {
      form.reset(data);
    } else if (result.fieldErrors) {
      // Set field errors from the API response
      Object.entries(result.fieldErrors).forEach(([field, message]) => {
        form.setError(field as keyof UserFormModel, {
          type: 'manual',
          message: message,
        });
      });
    }
  };

  return <UserFormDisplay form={form} onSubmit={handleSubmit} isCreate={isCreate} userId={userId} userData={userData} />;
};

export default UserFormLogic;
